import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, SelectProps, Space, Tooltip, Modal, DatePicker } from "antd";
import { useParams } from "react-router-dom";
import HTTPService from "../../../utils/makerequest";
import { ICompanyData } from "../../../interfaces/ICompanyData";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { IPageProps } from "../../../interfaces/page-data";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";
import { IInventory } from "../../../interfaces/IItemData";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, PlusOutlined, UnorderedListOutlined, SyncOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import { Box } from "@material-ui/core";
import { Toast } from 'primereact/toast';
import AddActivityName from "./AddActivityName";
import { IUser } from "../../../interfaces/IUser";
import Dropdown from "../../../AltisComponent/Dropdown";

const UpdateFault: React.FunctionComponent<IPageProps> = (props) => {
    const { maintenanceId } = useParams<any>();
    const [careData, setCareData] = useState<any>();
    const [companyData, setCompanyData] = useState<ICompanyData[]>();
    const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
    const [activityData, setActivityData] = useState<any>();
    const [inventoryData, setInventoryData] = useState<IInventory>();
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [maintenanceType, setMaintenanceType] = useState<number>();
    const [isModalVisibleCare, setIsModalVisibleCare] = useState(false);
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const { t } = useTranslation();
    const toast = useRef<Toast>(null);
    const [form] = Form.useForm();
    const [showCustomFrequency, setShowCustomFrequency] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [selectedActivity, setSelectedActivity] = useState<number | undefined>(form.getFieldValue('activityId'));
    const [userData, setUserData] = useState<IUser[]>();

    useEffect(() => {
        props.onSetPage({
            title: t('faultUpdate')
        });

        const loadInitialData = async () => {
            await fetchData(); // Company verilerini yükle
            await fetchActivity(userInfo?.companyId); // Activity verilerini yükle
            await getUserData(userInfo?.companyId);
            if (maintenanceId && parseInt(maintenanceId) !== 0) {
                await getFaultId(parseInt(maintenanceId)); // Fault verilerini yükle
            } else {
                setCareData({
                    repeatMaintenanceTBL: [],
                    count: 0
                });
            }
        };

        loadInitialData();
    }, []);

    useEffect(() => {
        setShowCustomFrequency(form.getFieldValue('repeatActivity') === 'Custom');
    }, [form.getFieldValue('repeatActivity')]);

    const getUserData = (companyId: number) => {
        HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
            .then((res) => {
                if (!res.data) {
                    return;
                }
                if (res.status === 200) {
                    setUserData(res.data);
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: res.error.message,
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    };


    const fetchData = async () => {
        const result = await HTTPService.GETCompanyNames();
        setCompanyData(result);
    };

    const savedNewCare = async (newActivity: any) => {
        try {
            setActivityData(prevData => {
                const updatedData = prevData ? [...prevData] : [];
                updatedData.push(newActivity);
                return updatedData;
            });

            form.setFieldValue('activityId', newActivity.activityId);
            setSelectedActivity(newActivity.activityId);

            setIsModalVisibleCare(false);

            toast.current?.show({
                severity: 'success',
                summary: t('success'),
                detail: t('activity_added_successfully'),
                life: 3000
            });
        } catch (error) {
            console.error('Error saving activity:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_saving_activity'),
                life: 3000
            });
        }
    };

    const getFaultId = async (maintenanceId: number) => {
        try {
            const res = await HTTPService.GET(`/Maintenance/MaintenanceById?maintenanceId=${maintenanceId}`);
            if (res.status === 200 && res.data) {

                if (!activityData || activityData.length === 0) {
                    await fetchActivity(userInfo?.companyId);
                }

                const formValues = {
                    activityId: res.data.activityId,
                    description: res.data.description,
                    priority: res.data.priority,
                    maintenanceExternalResponsibleName: res.data.maintenanceExternalResponsibleName,
                    maintenanceExternalResponsibleMail: res.data.maintenanceExternalResponsibleMail
                };

                setCareData(res.data);
                setSelectedActivity(res.data.activityId);
                setInitialValues(formValues);

                form.resetFields();
                form.setFieldsValue(formValues);

            }
        } catch (error) {
            console.error("Error fetching maintenance data:", error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_fetching_data'),
                life: 3000
            });
        }
    };

    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role !== UserRole.Admin
            ? [
                {
                    title: t('Company Name'),
                    key: 'companyName',
                    placeHolder: t('Company Name'),
                    isSorting: true,
                },
            ]
            : []),
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 250
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 250
        },
        {
            title: t('item_type'),
            isSorting: true,
            key: 'typeName',
            placeHolder: t('item_type'),
            width: 250
        },
        {
            title: t('item_group'),
            isSorting: true,
            key: 'categoryName',
            placeHolder: t('item_group'),
            width: 250
        },
        {
            title: t('location'),
            isSorting: true,
            key: 'locationName',
            placeHolder: t('actualLocation'),
            width: 250,
            render: (text, record) => (
                <div>
                    <span>{text}</span>
                    {record.locationName !== record.actualLocationName && (
                        <Tooltip title={record.actualLocationName}>
                            <span style={{ color: 'red', marginLeft: 8, cursor: 'pointer' }}>⚠️</span>
                        </Tooltip>
                    )}
                </div>
            ),
        },
        {
            title: t('inventory_status_name'),
            isSorting: true,
            key: 'inventoryStatusName',
            placeHolder: t('inventory_status_name'),
            width: 250
        },
    ];

    const columns1: IMUIDataGridColumns[] = [
        {
            title: t('inventoryName'),
            headerAlign: 'center',
            align: 'left',
            key: 'inventoryName',
            placeHolder: t('inventoryName'),
            width: 485,
            render: (text, record) => record?.inventoryTBL?.inventoryName
        },
        {
            title: t('barcode'),
            isSorting: true,
            key: 'barcode',
            placeHolder: t('barcode'),
            width: 490,
            render: (text, record) => record?.inventoryTBL?.barcode
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: true,
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <Space>
                        <Popconfirm
                            title={t('confirm_delete')}
                            onConfirm={() => handleDeleteItem(record.inventoryId)}
                            okText={t('yes')}
                            cancelText={t('no')}
                        >
                            <Tooltip title={t('delete')} placement="top">
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Tooltip>
                        </Popconfirm>
                    </Space>
                </div>
            ),
        }
    ];

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const InventoryFilter = (e?) => {
        const body = {
            pageSize: e?.pageSize || 10,
            page: e?.page || 1,
            barcode: e?.barcode,
            departmentName: e?.departmentName,
            inventoryName: e?.inventoryName,
            inventoryStatusName: e?.inventoryStatusName,
            typeName: e?.typeName,
            debtFirstName: e?.debtFirstName,
            debtLastName: e?.debtLastName,
            companyId: e?.companyId,
            companyName: e?.companyName,
            itemName: e?.itemName,
            itemGroup: e?.itemGroup,
            locationName: e?.locationName,
            categoryName: e?.categoryName,
            debbit: e?.debbit,
            responsible: e?.responsible,
            isPrinted: e?.isPrinted,
        };

        HTTPService.POST(`/Inventory/filters`, body).then((response) => {
            if (response.status === 200 && response.data) {
                setInventoryData(response.data);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: response.data,
                    life: 3000
                });
            }
        });
    };

    const handleAddSelectedItems = () => {
        if (!selectedItems || selectedItems.length === 0) {
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('anyInventory'),
                life: 3000
            });
            return;
        }

        const selectedItem = selectedItems[0];

        const newRepeatMaintenanceTBL = [{
            inventoryId: selectedItem.inventoryId,
            inventoryTBL: {
                inventoryName: selectedItem.inventoryName,
                barcode: selectedItem.barcode || selectedItem.customBarcode
            }
        }];

        setCareData({
            ...careData,
            repeatMaintenanceTBL: newRepeatMaintenanceTBL,
            count: 1
        });

        setSelectedItems([]);

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('assetAdd'),
            life: 3000
        });
    };

    const handleRowSelection = (selectedRowsData: any[]) => {
        setSelectedItems(selectedRowsData);
    };

    const handleDeleteItem = (inventoryId: number) => {
        const updatedRepeatMaintenanceTBL = careData?.repeatMaintenanceTBL.filter(
            item => item.inventoryId !== inventoryId
        );

        setCareData({
            ...careData,
            repeatMaintenanceTBL: updatedRepeatMaintenanceTBL
        });

        toast.current?.show({
            severity: 'success',
            summary: t('success'),
            detail: t('inventory_delete'),
            life: 3000
        });
    };

    const responsibleOptions = React.useMemo(() => {
        if (!userData) return [];
        const exists = userData.some(u => u.displayName === careData?.maintenanceExternalResponsibleName);
        if (careData?.maintenanceExternalResponsibleName && !exists) {
            return [
                ...userData,
                {
                    userId: careData.maintenanceResponsibleUserId ?? careData.maintenanceExternalResponsibleName,
                    displayName: careData.maintenanceExternalResponsibleName,
                    userEmail: careData.maintenanceExternalResponsibleMail,
                }
            ];
        }
        return userData;
    }, [userData, careData]);


    const UpdateFault = (formData) => {
        try {
            if (!careData?.repeatMaintenanceTBL || careData.repeatMaintenanceTBL.length === 0) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('please_select_inventory'),
                    life: 3000
                });
                return;
            }

            if (careData.repeatMaintenanceTBL.length > 1) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('only_one_inventory_allowed'),
                    life: 3000
                });
                return;
            }

            const latestInventory = careData.repeatMaintenanceTBL[careData.repeatMaintenanceTBL.length - 1];

            const maintenanceData = {
                inventoryId: latestInventory.inventoryId,
                activityId: selectedActivity,
                maintenanceId: parseInt(maintenanceId),
                description: formData.description,
                maintenanceExternalResponsibleName: formData.maintenanceExternalResponsibleName,
                maintenanceResponsibleUserId: formData.maintenanceResponsibleUserId,
                maintenanceExternalResponsibleMail: formData.maintenanceExternalResponsibleMail,
                maintenanceCreatedUserId: userInfo?.userId,
                priority: Number(formData.priority),
                companyId: userInfo?.companyId || selectedCompany,
                maintenanceType: 2,
                maintenanceStartDate: careData.maintenanceStartDate,
            };


            HTTPService.PUT(`/Maintenance/updateFault`, maintenanceData)
                .then((res) => {
                    if (res.status === 200) {
                        toast.current?.show({
                            severity: 'success',
                            summary: t('success'),
                            detail: t('faultUpdated'),
                            life: 3000
                        });
                        window.location.replace("/admin/fault-management/");
                    } else {
                        const errorMessage = typeof res.data === 'string' ? res.data : t('save_failed');
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: errorMessage,
                            life: 3000
                        });
                    }
                })
                .catch((error) => {
                    console.error('Save Error:', error);
                    const errorMessage = error?.response?.data?.title || t('save_failed');
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: errorMessage,
                        life: 3000
                    });
                });
        } catch (error) {
            console.error('Form processing error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('save_failed'),
                life: 3000
            });
        }
    };


    const handleCancelCare = () => {
        setIsModalVisibleCare(false);
    };

    const handleCancel = () => {
        window.location.replace("/admin/fault-management/");
    };

    const showModal = () => {
        setIsModalVisible(true);
        InventoryFilter();
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    const fetchActivity = async (companyId: number) => {
        try {
            const result = await HTTPService.GETActivityNames(companyId);
            setActivityData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const showModalCare = () => {
        setIsModalVisibleCare(true);
    };


    return (
        <>
            <Toast ref={toast} />
            <Form
                layout="vertical"
                onFinish={UpdateFault}
                form={form}
                initialValues={initialValues}
            >
                <Card style={{ padding: "50px" }}>

                    <Box>
                        {userInfo?.role === UserRole.AltisAdmin ? (
                            <Form.Item
                                name="companyId"
                                label={t('Select company')}
                                rules={[{ required: true, message: t('please_select_a_company') }]}
                                initialValue={selectedCompany}
                            >
                                <Select
                                    showSearch
                                    placeholder={t('company_name')}
                                    style={{ marginBottom: '6px' }}
                                    filterOption={filterOption}
                                    onChange={(value) => {
                                        setSelectedCompany(value);
                                        fetchActivity(value);
                                    }}
                                >
                                    {companyData?.map((company) => (
                                        <Select.Option key={company.companyId} value={company.companyId}>
                                            {company.companyName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : (
                            <Form.Item
                                name="companyId"
                                initialValue={userInfo?.companyId}
                                hidden
                            >
                                <Input type="hidden" />
                            </Form.Item>
                        )}
                        <Form.Item
                            name='activityId'
                            label={
                                <Tooltip title={t('activity_name')}>
                                    {t('activity_name')}
                                </Tooltip>
                            }
                            rules={[{ required: true, message: t('activity_name') }]}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Select
                                    placeholder={t('activity_name')}
                                    style={{ flex: 1 }}
                                    dropdownStyle={{ minWidth: 300 }}
                                    filterOption={filterOption}
                                    showSearch
                                    value={selectedActivity}
                                    onChange={(value) => {
                                        setSelectedActivity(value);
                                        form.setFieldsValue({ activityId: value });
                                    }}
                                >
                                    {activityData?.map(row => (
                                        <Select.Option key={row.activityId} value={row.activityId}>
                                            {row.activityName}
                                        </Select.Option>
                                    ))}
                                </Select>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={showModalCare}
                                />
                            </div>
                        </Form.Item>

                        <Modal
                            visible={isModalVisibleCare}
                            footer={null}
                            onCancel={handleCancelCare}
                            width={790}
                            bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                        >
                            <div style={{ flex: 1 }}>
                                <AddActivityName
                                    cancelModal={handleCancelCare}
                                    savedObj={savedNewCare}
                                    companyId={selectedCompany}
                                    activityName={careData?.activityName}
                                    onSetPage={props.onSetPage}
                                    getPageData={props.getPageData}
                                />
                            </div>
                        </Modal>

                        {maintenanceType == 1 && (
                            <>
                                <Form.Item
                                    label={t('activity_start_date')}
                                    name="maintenanceStartDate"
                                    rules={[{ required: true, message: t('select_date_time') }]}
                                >
                                    <DatePicker
                                        showTime
                                        format="DD-MM-YYYY HH:mm"
                                        placeholder={t('select_date_time')}
                                        style={{ borderRadius: '5px', width: '100%' }} />
                                </Form.Item>
                            </>
                        )}

                        <Form.Item
                            name="priority"
                            label={t('Priority')}
                            rules={[{ required: true, message: t('Priority') }]}
                        >
                            <Select
                                placeholder={t('Priority')}
                                style={{ marginBottom: '6px' }}
                                value={form.getFieldValue('priority')}
                            >
                                <Select.Option value={0}>{t('Low')}</Select.Option>
                                <Select.Option value={1}>{t('Medium')}</Select.Option>
                                <Select.Option value={2}>{t('High')}</Select.Option>
                                <Select.Option value={3}>{t('Highest')}</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={t('description_activity')}
                            name="description"
                            rules={[{ required: true, message: t('enter_description') }]}
                        >
                            <Input placeholder={t('enter_description')} style={{ borderRadius: '5px' }} />
                        </Form.Item>

                        <Form.Item
                            label={t('faultResponsible')}
                            name="maintenanceExternalResponsibleName"
                            rules={[{ required: true, message: t('maintenanceResponsible') }]}
                        >
                            <Dropdown
                                placeholder={t('maintenanceResponsible')}
                                dataSource={responsibleOptions}
                                allowCustomValue={true}
                                valueKey="userId"
                                style={{ width: '100%' }}
                                includeEmptyOption={false}
                                labelKey="displayName"
                                onChange={(value) => {
                                    const selectedUser = userData?.find(u => u.displayName === value || u.userId === value);
                                    form.setFieldsValue({
                                        maintenanceExternalResponsibleName: selectedUser ? selectedUser.displayName : value,
                                        maintenanceResponsibleUserId: selectedUser ? selectedUser.userId : null,
                                        maintenanceExternalResponsibleMail: selectedUser?.userEmail || undefined
                                    });
                                }}
                            />
                        </Form.Item>

                        <Form.Item name="maintenanceResponsibleUserId" hidden>
                            <Input type="hidden" />
                        </Form.Item>

                        <Form.Item
                            label={t('email')}
                            name="maintenanceExternalResponsibleMail"
                            rules={[{ required: true }]}
                        >
                            <Dropdown
                                placeholder={t('email')}
                                dataSource={userData}
                                valueKey="userEmail"
                                labelKey="userEmail"
                                style={{ width: '100%' }}
                                includeEmptyOption={false}
                                allowCustomValue={true}
                            />
                        </Form.Item>

                        {maintenanceType === 1 && (
                            <>
                                <Form.Item
                                    name='repeatActivity'
                                    label={t('repeat_activity')}
                                    rules={[{ required: true, message: t('repeat_activity') }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder={t('repeat_activity')}
                                        onChange={(value) => {
                                            setSelectedActivityType(value);
                                            setShowCustomFrequency(value === 'Custom');
                                        }}
                                    >
                                        <Select.Option value={0}>{t('onetime')}</Select.Option>
                                        <Select.Option value={1}>{t('daily')}</Select.Option>
                                        <Select.Option value={7}>{t('weekly')}</Select.Option>
                                        <Select.Option value={30}>{t('monthly')}</Select.Option>
                                        <Select.Option value={365}>{t('yearly')}</Select.Option>
                                        <Select.Option value="Custom">{t('custom')}</Select.Option>
                                    </Select>
                                </Form.Item>

                                {showCustomFrequency && (
                                    <Form.Item
                                        name="frequency"
                                        label={t('frequency_days')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('frequency_days')
                                            },
                                            {
                                                pattern: /^[0-9]*$/,
                                                message: t('please_enter_valid_number')
                                            }
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('frequency_days')}
                                            style={{ borderRadius: '5px' }}
                                            type="number"
                                            min={1}
                                        />
                                    </Form.Item>
                                )}
                            </>
                        )}

                        <Button
                            onClick={showModal}
                            type="primary"
                            style={{ marginTop: 10, marginRight: 10, borderRadius: '5px' }}
                            icon={<UnorderedListOutlined />}
                        >
                            {t('first_datagrid')}
                        </Button>

                        <Modal
                            title={t('first_datagrid')}
                            visible={isModalVisible}
                            onCancel={handleModalCancel}
                            width={1200}
                            footer={[
                                <Button
                                    key="add"
                                    type="primary"
                                    onClick={() => {
                                        handleAddSelectedItems();
                                        handleModalCancel();
                                    }}
                                >
                                    {t('add_selected_items')}
                                </Button>
                            ]}
                        >
                            <MUIDatagrid
                                data={inventoryData?.data}
                                columns={columns}
                                enableSelection={true}
                                onSelectionChange={handleRowSelection}
                                singleSelection={true}
                                onChange={InventoryFilter}
                                total={inventoryData?.count}
                            />
                        </Modal>

                        <MUIDatagrid
                            data={careData?.repeatMaintenanceTBL}
                            columns={columns1}
                            onChange={InventoryFilter}
                            total={careData?.count}
                        />

                        <Form.Item>
                            <Row gutter={[4, 4]} justify="end" align="middle">
                                <Col xs={12} sm={4}>
                                    <Button
                                        block
                                        onClick={handleCancel}
                                        type="primary"
                                        style={{
                                            height: 64,
                                            backgroundColor: 'transparent',
                                            color: '#1890ff',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                            e.currentTarget.style.color = '#40a9ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                            e.currentTarget.style.color = '#1890ff';
                                        }}
                                    >
                                        <CloseOutlined style={{ fontSize: 20 }} />
                                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                            {t('cancel')}
                                        </span>
                                    </Button>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <Button
                                        block
                                        htmlType="submit"
                                        type="primary"
                                        style={{
                                            height: 64,
                                            backgroundColor: 'transparent',
                                            color: '#1890ff',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                            e.currentTarget.style.color = '#40a9ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                            e.currentTarget.style.color = '#1890ff';
                                        }}
                                    >
                                        <SyncOutlined style={{ fontSize: 20 }} />
                                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                            {t('update')}
                                        </span>
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Box>
                </Card>
            </Form>
        </>
    );
};

export default UpdateFault;
